// User Feedback Form Component
export default {
  // Page Title
  title: "User Feedback List",
  subtitle: "Problems encountered during use?",

  // Form Labels
  problemType: "Problem Type",
  problemDescription: "Problem Description",
  phoneNumber: "Phone Number",
  email: "Email",

  // Problem Type Options
  problemFeedback: "Problem Feedback",
  featureSuggestion: "Feature Suggestion",
  caseAssistance: "Case Assistance",

  // Placeholders
  phonePlaceholder: "Please enter phone number",
  emailPlaceholder: "Please enter email",

  // Buttons
  reset: "Reset",
  submit: "Submit",
  close: "Close",
  confirm: "Confirm",

  // Success Message
  submitSuccess: "Submitted successfully, thank you for your suggestion",

  // Form Validation
  phoneRequired: "Please enter phone number",
  phoneLengthRule: "Length should be 7 to 12 characters",
  emailRequired: "Please enter email",
  typeRequired: "Please select problem type",
  contentRequired: "Please fill in problem description",
};
